import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { pdfjs, Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { useIsMobile } from '../../hooks/useIsMobile';

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.mjs';

interface PdfViewerWithPaginationProps {
  pdfData: string; // base64 データを Blob に変換して URL
  initialPage?: number; // モバイル対応(引用表示PDF)のために追加
}

const PdfViewerWithPagination: React.FC<PdfViewerWithPaginationProps> = ({
  pdfData,
  initialPage = 1, // デフォルトは1ページ目（モバイル対応のために追加）
}) => {
  const [numPages, setNumPages] = useState<number | null>(null); // PDF の総ページ数
  const [pageNumber, setPageNumber] = useState<number>(initialPage); // 現在のページ番号 モバイル対応のため1→initialPageに変更

  // PDF 読み込み時にページ数を取得
  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
    //setPageNumber(1); // 最初のページを表示 （モバイル対応時にコメントアウト）
  };

  const goToPreviousPage = () => {
    setPageNumber((prevPage) => Math.max(prevPage - 1, 1));
  };

  const goToNextPage = () => {
    setPageNumber((prevPage) => (numPages ? Math.min(prevPage + 1, numPages) : prevPage));
  };

  const isMobile = useIsMobile();
  const pdfContainerRef = useRef<HTMLDivElement>(null);
  const [containerWidth, setContainerWidth] = useState<number | undefined>(undefined);

  useEffect(() => {
    setPageNumber(initialPage);
  }, [initialPage]);

  useLayoutEffect(() => {
    if (isMobile && pdfContainerRef.current) {
      const width = pdfContainerRef.current.clientWidth;
      setContainerWidth(width);
    }
  }, [isMobile, pdfData, pageNumber]);

  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ marginTop: isMobile ? '0px' : '10px' }}>
        <button onClick={goToPreviousPage} disabled={pageNumber <= 1}>
          Previous
        </button>
        <span style={{ margin: '0 10px' }}>
          Page {pageNumber} of {numPages}
        </span>
        <button onClick={goToNextPage} disabled={pageNumber >= (numPages || 1)}>
          Next
        </button>
      </div>
      <div ref={pdfContainerRef} style={{
        width: '100%',
        maxWidth: '100%',
        overflow: 'hidden'
      }}>
        {pdfData ? (
          <Document
            file={pdfData}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={(error) => console.error('PDF Load Error:', error)}
            loading="Loading PDF..."
          >
            <Page
              key={`page-${pageNumber}`}
              pageNumber={pageNumber} 
              renderMode="canvas"
              renderTextLayer={false}
              width={isMobile ? containerWidth : undefined}
              scale={isMobile && !containerWidth ? 0.90: 1}
            />
          </Document>
        ) : (
          <p>Loading...</p>
        )}
      </div>

    </div>
  );
};

export default PdfViewerWithPagination;
